/*
 * @Author: yukizou yukizou@tencent.com
 * @Date: 2025-08-06 20:10:18
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-08-06 20:10:32
 */
export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
